export default {
  fetching: true,
  images: [],
}
